import React from 'react';
import fingerprintScanning from '../assets/images/scannerLoading.gif';
import '../styles/fingerprintScannerLoader.css'; // CSS for styling

// Define the component as a React Functional Component
const FingerprintScannerLoader = () => {
  return (
    <div className="overlay">
      <div className="popup-overlay">
        <div className="loader-container">
          <img src={fingerprintScanning} alt="Fingerprint Scanning" className="loader-image" loading="lazy" />
          
        </div>
        
      </div>
      
    </div>
  );
}

export default FingerprintScannerLoader;


